import { type SalesChannelWithTelesales } from "@/scalars/salesChannelChoices"
import {
    AFFILIATE_LINK_CUSTOM_PARAMS,
    AFFILIATE_ORGANISATION_CUSTOM_PARAMS,
    type CustomParamsFormValues,
    SALES_CHANNEL_CUSTOM_PARAMS,
} from "../constants/customisableAffiliates/defaultFormValues"

function isAffiliateWithCustomParams(
    affiliateCode?: string | null
): affiliateCode is keyof typeof AFFILIATE_LINK_CUSTOM_PARAMS {
    return affiliateCode ? affiliateCode in AFFILIATE_LINK_CUSTOM_PARAMS : false
}

function isAffiliateOrganisationWithCustomParams(
    affiliateOrganisation?: string | null
): affiliateOrganisation is keyof typeof AFFILIATE_ORGANISATION_CUSTOM_PARAMS {
    return affiliateOrganisation
        ? affiliateOrganisation in AFFILIATE_ORGANISATION_CUSTOM_PARAMS
        : false
}

type GetOnboardingConfigProps = {
    salesChannel: SalesChannelWithTelesales
    affiliateCode?: string | null
    affiliateOrganisation?: string | null
}

export function getOnboardingConfig(props: GetOnboardingConfigProps) {
    let config: CustomParamsFormValues = {
        ...SALES_CHANNEL_CUSTOM_PARAMS[props.salesChannel],
    }

    if (isAffiliateWithCustomParams(props.affiliateCode)) {
        config = {
            ...config,
            ...AFFILIATE_LINK_CUSTOM_PARAMS[props.affiliateCode],
        }
    }

    if (isAffiliateOrganisationWithCustomParams(props.affiliateOrganisation)) {
        config = {
            ...config,
            ...AFFILIATE_ORGANISATION_CUSTOM_PARAMS[props.affiliateOrganisation],
        }
    }

    return config
}
